import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import { ReactComponent as TickIconUniversal } from "../../../assets/images/icons/TickUniversal.svg";
import { ReactComponent as CloseIconUniversalWhite } from "../../../assets/images/icons/CloseIconUniversalWhite.svg";
import { ReactComponent as ErrorIconUniversal } from "../../../assets/images/icons/ErrorImageIconUniversal.svg";
import { ReactComponent as WarningIconUniversal } from "../../../assets/images/icons/WarningIconUniversal.svg";
import { ReactComponent as InfoIconUniversal } from "../../../assets/images/icons/InfoIconUniversal.svg";
import { ReactComponent as RevertBackIcon } from "../../../assets/images/icons/revertBackIcon.svg";
import { WidthFull } from "@mui/icons-material";

const FirstMessage = ({
  type,
  message,
  visible = false,
  onHide,
  onRevert,
  onConfirm, // New: Called after timeout if not reverted
  counter = 0,
}) => {
  // const type="revert"
  // const message=""
  // const visible=true
  const [isVisible, setIsVisible] = useState(true);
  const [reverted, setReverted] = useState(false);
  const [progress, setProgress] = useState("100%");
  useEffect(() => {
    if (visible) {
      setIsVisible(true);
      setReverted(false);

      // Reset progress immediately
      setProgress("100%");

      // Trigger transition in next tick
      const animationTrigger = setTimeout(() => {
        setProgress("0%");
      }, 100); // use 10ms to ensure DOM flush

      return () => clearTimeout(animationTrigger);
    } else {
      setIsVisible(false);
    }
  }, [visible, counter]); // 👈 include `counter`

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(
        () => {
          if (!reverted && onConfirm) onConfirm(); // API call here
          onHide();
        },
        type === "revert" ? 3000 : 1500
      );

      return () => clearTimeout(timer);
    }
  }, [isVisible, reverted, type === "revert", onConfirm, onHide, counter]);

  const handleRevert = () => {
    setReverted(true);
    if (onRevert) onRevert();
    onHide();
  };

  const notificationTypes = {
    success: {
      class: "bg-[#00BA00] text-white",
      text: "Success !",
      icon: <TickIconUniversal className="w-[18px] h-[18px]" />,
    },
    danger: {
      class: "bg-[#FF1515] text-white",
      text: "Failure !",
      icon: <ErrorIconUniversal className="w-[18px] h-[18px]" />,
    },
    info: {
      class: "bg-blue-600 text-white",
      text: "Alert !",
      icon: <InfoIconUniversal className="w-[18px] h-[18px]" />,
    },
    warning: {
      class: "bg-[#FF951C] text-white",
      text: "Warning !",
      icon: <WarningIconUniversal className="w-[18px] h-[18px]" />,
    },
    revert: {
      class: "bg-[#FF951C] text-white",
      text: "Revert Back ?",
      icon: <RevertBackIcon className="w-[18px] h-[18px]" />,
    },
  };

  const ProgressBar = ({ progress }) => {
    const barRef = useRef(null);

    useLayoutEffect(() => {
      const bar = barRef.current;
      if (!bar) return;

      // Reset styles before applying transition
      bar.style.transition = "none";
      bar.style.width = "100%"; // reset instantly

      // Force reflow (flush styles)
      void bar.offsetWidth;

      // Now apply transition to new progress value
      bar.style.transition = "width 3s linear";
      bar.style.width = progress;
    }, [progress]); // 👈 triggers this on change

    return <div ref={barRef} className="h-full bg-[#583A0B] rounded width-[130px]" />;
  };

  const getPositionClasses = () => {
    if (type === "revert") {
      return {
        positionClass: "bottom-6 left-6",
        transformStyle: { transform: isVisible ? "translateX(0)" : "translateX(-100%)" },
      };
    } else {
      return {
        positionClass: "top-12 right-4",
        transformStyle: { transform: isVisible ? "translateX(0)" : "translateX(100%)" },
      };
    }
  };

  const { positionClass, transformStyle } = getPositionClasses();

  return (
    isVisible &&
    ReactDOM.createPortal(
      <div
        className={`fixed z-[9999999999] pointer-events-auto transition-transform duration-1000 ease-in-out ${positionClass} shadow-lg`}
        style={transformStyle}
      >
        <div
          className={`inline-flex relative flex-col items-start gap-2 leading-none rounded-l-[5px] rounded-r-none p-3 shadow text-sm ${notificationTypes[type]?.class} `}
        >
          <div className="flex gap-x-3">
            <div className="flex">
              {notificationTypes[type]?.icon}
              <div className="flex flex-col items-start gap-x-2">
                <div className="px-1 text-white text-base">{notificationTypes[type]?.text}</div>
                {message && <div className="px-1 text-white text-sm">{message}</div>}
              </div>
            </div>
            {type === "revert" && (
              <button
                onClick={handleRevert}
                className="text-md text-[#C8923B] bg-white hover:text-gray-200 px-4 py-2 rounded"
              >
                Undo
              </button>
            )}
          </div>

          {/* ⬇️ Progress Bar */}
          {type === "revert" && (
            <div className="w-full h-[4px] bg-white/30 rounded">{<ProgressBar progress={progress} />}</div>
          )}
        </div>
      </div>,
      document.getElementById("portal-root")
    )
  );
};

export default FirstMessage;
